<template>
  <LoadingCircle v-if="isLoading" />
  <div v-else>
    <v-expansion-panels
      id="display-questionnaire__sections"
      v-model="openAll"
      multiple
    >
      <v-expansion-panel
        v-for="qs in template?.questionSets"
        :key="qs.id"
        :value="qs.title"
        elevation="0"
      >
        <v-expansion-panel-title>
          <p class="text-left">{{ qs.title }}</p>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row v-for="(itemRow, index) in qs.questionModels" :key="index">
            <v-col v-bind="q.layout" v-for="q in itemRow" :key="q.question.id">
              <div class="mb-5 text-left">
                <QuestionSelector
                  :key="q.question.id"
                  :question-model="q"
                  :is-read-only-mode="true"
                />
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup lang="ts">
import QuestionSelector from "@/components/questionnaire/QuestionSelector.vue";
import type { QuestionnaireTemplate } from "@/models/questionnaireTemplate";
import { onBeforeMount, ref } from "vue";
import LoadingCircle from "@/components/custom/LoadingCircle.vue";
import { QuestionnaireLanguage } from "@/models/enum/questionnaireLanguage";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";

const props = defineProps<{
  templateLabel: string;
}>();

const selectedQuestionnaire = useSelectedQuestionnaire();

const isLoading = ref(false);
const template = ref<QuestionnaireTemplate>();
let openAll = ref(new Array<String>());

onBeforeMount(async () => {
  isLoading.value = true;
  template.value = await selectedQuestionnaire.getSelectedQuestionnaireTemplate(
    props.templateLabel,
    QuestionnaireLanguage.En
  );
  isLoading.value = false;
});
</script>
